
import TimeLineItem from '../scheduler/TimeLineItem.vue'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
    components: {
        TimeLineItem
    },
})

export default class SchedulerItemRow extends Vue {
    @Prop({ type: String, default: "" }) readonly backGroundColor!: string;
    @Prop({ type: Array, default: null }) readonly weekDates!: any[];
    @Prop({ type: Array, default: null }) readonly quarterMonths!: any[];
    @Prop({ type: Array, default: null }) readonly weeks!: any[];
    @Prop({ type: Boolean, default: null }) readonly isDays!: boolean;
    @Prop({ type: Boolean, default: null }) readonly isMonths!: boolean;
    @Prop({ type: Boolean, default: null }) readonly isWeeks!: boolean;
    @Prop({ type: String, default: null }) readonly columnSpan!: string;
    @Prop({ type: Number, default: 0 }) readonly leftMargin!: string;



}
